import { UseMutationOptions } from '@tanstack/react-query';
import merge from 'lodash-es/merge';
import { OneMutationService } from 'types/services/services';

export type MutationOptions<Data, Params> = Omit<UseMutationOptions<Data, unknown, Params>, 'mutationFn'> & { serviceId?: string };

const mutationServiceOptionsToTQMutationOptions = <Data, Params>(
  service: OneMutationService<Data, Params>,
  opts?: MutationOptions<Data, Params>,
): MutationOptions<Data, Params> => {
  const { options } = service;
  const key = opts?.mutationKey ?? options?.mutationKey ?? `${service.serviceId}-${service.id}`;

  return merge({}, options, opts, { mutationKey: [key] });
};

export default mutationServiceOptionsToTQMutationOptions;
